import React from 'react';
import { Participation } from '@app/api';
import { useTranslation } from 'react-i18next';

export const DurationCell = ({
  participation,
}: {
  participation: Participation;
}) => {
  const { t } = useTranslation();
  return (
    <td key="duration">
      {t('sessions.details.participantsDetails.duration', {
        value: participation.effectiveDuration,
      })}
    </td>
  );
};
